
import React, {useEffect, useState, Fragment} from 'react';
import { useMutation } from "react-query";
import apiClient from "../../http-common";
import {
    triggerSuccess,
    triggerError,
    setErrorMessage,
    setSuccessMessage,
  } from '../Request/StatusFormatter';

const ManageTransfer = () => {

    const [transfer, settransfer] = useState('');   
    const getAmount = (amount)=> new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', currencySign: 'accounting' }).format(amount);
    const getDate = (date) => new Date(date).toDateString();

    const { isLoading: isApprovingtransfer, mutate: approvetransfer } = useMutation(        
        async () => {
          return await apiClient.post(`/api/approve-transfer/${transfer.id}`);
        },
        {
          onSuccess: (res) => {
            setSuccessMessage(res.data);
            triggerSuccess(); 
            
          },
          onError: (err) => {
            setErrorMessage(err.response?.data || err);         
            triggerError();
          },
        }
      );

    const { isLoading: isDceliningtransfer, mutate: declinetransfer } = useMutation(        
        async () => {
          return await apiClient.post(`/api/decline-transfer/${transfer.id}`);
        },
        {
          onSuccess: (res) => {
            setSuccessMessage(res.data);
            triggerSuccess(); 
            
          },
          onError: (err) => {
            setErrorMessage(err.response?.data || err);         
            triggerError();
          },
        }
      );
    
    useEffect(() => {
        window.addEventListener('adminhistorytransferSelected', function (e) {
            let selectedtransfer = localStorage.getItem('adminhistorytransferSelected');
            if (selectedtransfer != null) {
                selectedtransfer = JSON.parse(selectedtransfer); 
                settransfer(selectedtransfer);
            }
        }, false);
    })
  return (
    <div>
        <div id="admin-transfer-history-menu" className="offcanvas offcanvas-bottom offcanvas-attached">
            <div className="menu-size" style={{height:"480px"}}>
                {transfer !== '' &&
                <div className="content">
                <a href="/#" className="d-flex py-1 pb-4">
                    <div className="align-self-center">
                        <span className="icon rounded-s me-2 gradient-highlight shadow-bg shadow-bg-xs"><i className="bi bi-person-circle font-18 color-white"></i></span>
                    </div>
                    <div className="align-self-center ps-1">
                        <h5 className="pt-1 mb-n1">{transfer.user.email}</h5>
                        <p className="mb-0 font-11 opacity-70">{getAmount(transfer.amount)}</p>
                    </div>
                    <div className="align-self-center ms-auto text-end">
                    {transfer.status === 'pending' && <h4 className="pt-1 font-14 mb-n1 color-yellow-dark">{transfer.status}</h4>}
                    {transfer.status === 'waiting approval' && <h4 className="pt-1 font-14 mb-n1 color-yellow-dark">{transfer.status}</h4>}
                    {transfer.status === 'approved' && <h4 className="pt-1 font-14 mb-n1 color-highlight-dark">{transfer.status}</h4>}
                    {transfer.status === 'completed' && <h4 className="pt-1 font-14 mb-n1 color-theme">{transfer.status}</h4>}
                    {transfer.status === 'declined' && <h4 className="pt-1 font-14 mb-n1 color-red-dark">{transfer.status}</h4>}
                    <p className="mb-0 font-11"> {getDate(transfer.created_at)}</p>
                    </div>
                </a>
                <div className="row">
                    <strong className="col-5 color-theme">transfer Amount</strong>
                    <strong className="col-7 text-end">{getAmount(transfer.amount)}</strong>
                    <div className="col-12 mt-2 mb-2"><div className="divider my-0"></div></div>

                    <strong className="col-5 color-theme">transfer Date </strong>
                    <strong className="col-7 text-end">{getDate(transfer.created_at)}</strong>
                    <div className="col-12 mt-2 mb-2"><div className="divider my-0"></div></div>

                    <strong className="col-5 color-theme">Accunt Number </strong>
                    <strong className="col-7 text-end">{transfer.account_number}</strong>
                    <div className="col-12 mt-2 mb-2"><div className="divider my-0"></div></div>

                    <strong className="col-5 color-theme">Sender Email</strong>
                    <strong className="col-7 text-end">{transfer.user.email}</strong>
                    <div className="col-12 mt-2 mb-2"><div className="divider my-0"></div></div> 

                    {/* <strong className="col-5 color-theme">transfer Wallet </strong>
                    <strong className="col-7 text-end color-highlight">{transfer.wallet.wallet_name}</strong>
                    <div className="col-12 mt-2 mb-2"><div className="divider my-0"></div></div>
                                      
                    <strong className="col-5 color-theme">Wallet Address </strong>
                    <strong className="col-7 text-end color-highlight">{transfer.wallet.wallet_address}</strong>
                    <div className="col-12 mt-2 mb-2"><div className="divider my-0"></div></div> */}

                    {/* <strong className="col-5 color-theme">transfer Plan</strong>
                    <strong className="col-7 text-end">{transfer.plan.name}</strong>
                    <div className="col-12 mt-2 mb-4"><div className="divider my-0"></div></div> */}
                    {(transfer.status === 'pending' || transfer.status === 'waiting approval' )&&
                    <Fragment>
                        <div className="col-6">
                            <div onClick={approvetransfer} className="btn btn-s btn-full gradient-highlight shadow-bg shadow-bg-xs">
                            {isApprovingtransfer ? <span>Approving...</span>: <span>Approve</span>} 
                            </div>
                        </div>
                        <div className="col-6">
                            <div onClick={declinetransfer} className="btn btn-s btn-full gradient-red shadow-bg shadow-bg-xs">
                                {isDceliningtransfer ? <span>Declining...</span>: <span>Decline</span>} 
                            </div>
                        </div>
                    </Fragment>                    
                    }
                </div>
            </div>
                }
            </div>
        </div>
    </div>
  )
}

export default ManageTransfer